/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Upload_BadgeInputs */

const en_features_upload_badge = /** @type {(inputs: Features_Upload_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works with any file type`)
};

const es_features_upload_badge = /** @type {(inputs: Features_Upload_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciona con cualquier tipo de archivo`)
};

/**
* | output |
* | --- |
* | "Works with any file type" |
*
* @param {Features_Upload_BadgeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_upload_badge = /** @type {((inputs?: Features_Upload_BadgeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Upload_BadgeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_upload_badge(inputs)
	return en_features_upload_badge(inputs)
});